module.exports = __webpack_public_path__ + "media/images/common/change_btn_l_ov-e74cad95dd8fb49de7e4627f65665477.png";